module.exports = __webpack_public_path__ + "static/people_pop29-9fe8c4bccb07e267ff9ec390dec21657.png";